var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mia-ReportFilters" }, [
    _c(
      "div",
      { staticClass: "mia-ReportFiltersDropdownGroup" },
      [
        _c("label", {
          directives: [
            {
              name: "tr",
              rawName: "v-tr",
              value: "report_filters_subject_label",
              expression: "'report_filters_subject_label'"
            }
          ],
          staticClass: "mia-ReportFiltersDropdownGroupLabel"
        }),
        _vm._v(" "),
        _c("subject-selection-dropdown", {
          attrs: { "subject-options": _vm.subjectOptions },
          on: { subjectInput: _vm.onSubjectInput }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mia-ReportFiltersDropdownGroup" },
      [
        _c("label", {
          directives: [
            {
              name: "tr",
              rawName: "v-tr",
              value: "report_filters_course_label",
              expression: "'report_filters_course_label'"
            }
          ],
          staticClass: "mia-ReportFiltersDropdownGroupLabel"
        }),
        _vm._v(" "),
        _c("course-selection-dropdown", {
          attrs: { "course-options": _vm.courseOptions },
          on: { courseInput: _vm.onCourseInput }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }